import { useState } from 'react'
import { Button } from '@/atoms/Button'
import { ArrowLeftIcon } from '@/atoms/Icons/ArrowLeftIcon'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { TicketIcon } from '@/atoms/Icons/TicketIcon'
import { AsH2, AsP, HeadingLG, ParagraphLG } from '@/atoms/Text/Text'
import { Modal } from '@/molecules/Modal'
import { useTranslate } from '@/utils/translate/translate-client'

interface Props {
  isStreaming: boolean
}

export const AudienceInterestTermsAndConditions = ({ isStreaming }: Props) => {
  const { t } = useTranslate('guild-voting')
  const [isTermsAndConditionsOpen, setIsTermsAndConditionsOpen] = useState(false)

  const showTermsAndConditions = () => {
    setIsTermsAndConditionsOpen(true)
  }

  const hideTermsAndConditions = () => {
    setIsTermsAndConditionsOpen(false)
  }

  return (
    <>
      <div className="text-sm text-gray-400 underline hover:cursor-pointer" onClick={showTermsAndConditions}>
        {t('termsAndConditions', 'Terms & Conditions')}.
      </div>

      <Modal isOpen={isTermsAndConditionsOpen} onClose={hideTermsAndConditions}>
        <div className="flex flex-col items-center justify-center gap-8 p-2">
          <div
            className="flex items-center justify-center self-end rounded-full bg-core-gray-200 p-2 hover:cursor-pointer"
            onClick={hideTermsAndConditions}
          >
            <CloseIcon color="core-gray-800" size={28} />
          </div>
          <div className="flex items-center justify-center rounded-full bg-warning-50 p-4">
            <TicketIcon color="warm-03" size={40} />
          </div>
          <HeadingLG as={AsH2} className="text-center" weight="bold">
            {t('termsAndConditions', 'Terms & Conditions')}
          </HeadingLG>
          <ParagraphLG as={AsP} className="px-8 text-center" color="core-gray-700">
            {isStreaming
              ? // this is a placeholder for the terms and conditions
                t(
                  'yourPurchaseGivesYouAccessToAllContentOnAngelRightNow',
                  'Your purchase gives you access to all content on Angel Studios right now. This film may or may not be available on Angel in the future.',
                )
              : t(
                  'yourPurchaseIsNonRefundableIfThisMovieNeverGoesToTheater',
                  'Your purchase is non-refundable. if this movie never goes to theaters, your ticket(s) will be valid towards any Angel Studios movie in theatres.',
                )}
          </ParagraphLG>
          <Button variant="black" size="lg" className="mt-8 flex w-1/2 gap-4" onClick={hideTermsAndConditions}>
            <ArrowLeftIcon size={28} /> <span>{t('returnToFilm', 'Return to film')}</span>
          </Button>
        </div>
      </Modal>
    </>
  )
}
